import { StyledEngineProvider, ThemeProvider } from "@mui/material";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { createHashRouter, RouterProvider } from "react-router-dom";
import App from "./components/Layout/App";
import { Routing } from "./data/Constants/Routing";
import "./index.css";
import { store } from "./state/Store";
import theme from "./theme";
import { setGlobalRequestConfig } from "@miragon/react-utils-api";
import LoginService from "./util/LoginService";
import { getHeaders } from "./util/AuthorizationUtils";


const callback = () => setGlobalRequestConfig(getHeaders());
LoginService.setAuthSuccessCallback(callback);
LoginService.setAuthRefreshSuccessCallback(callback);

LoginService.initKeycloak(() => {
    const router = createHashRouter([{
        path: Routing.Root.Route,
        index: true,
        element: <App />
    }]);

    const root = createRoot(document.getElementById("root")!);
    root.render((
        <Provider store={store}>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                    <RouterProvider router={router} />
                </ThemeProvider>
            </StyledEngineProvider>
        </Provider>
    ));
});
